/**
 * WhyChooseSection — heading + body + 4 bullet points.
 * Path: whyChoose.{heading, body, bullets[0..3]}
 *
 * Bullets is an array of strings.  We render 4 fixed rows (the design uses
 * exactly 4 bullet points).  If we ever need variable-length lists, we'll
 * use ItemListEditor — but matching the design's tight layout keeps things
 * predictable.
 */

import { BilingualTextField, BilingualTextareaField, SectionPanel } from '../fields/BilingualFields'

export default function WhyChooseSection({ getField, setField }) {
  return (
    <SectionPanel title="Why Choose OVACS?" subtitle="Heading + body paragraph + 4 bullet points">
      <BilingualTextField label="Heading" path="whyChoose.heading" getField={getField} setField={setField} />
      <BilingualTextareaField label="Body paragraph" path="whyChoose.body" getField={getField} setField={setField} rows={4} />

      <hr className="my-3 border-gray-200" />
      <h4 className="text-sm font-semibold text-gray-700 mb-2">Bullet points</h4>
      {[0, 1, 2, 3].map((i) => (
        <BilingualTextField
          key={i}
          label={`Bullet ${i + 1}`}
          path={`whyChoose.bullets.${i}`}
          getField={getField} setField={setField}
        />
      ))}
    </SectionPanel>
  )
}
